import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tableClaimsView.
 * @extends JetView
 */
export default class tableClaimsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} Configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Main view type
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scroll: true, // Enable scrolling
            columns: [
                // Column definitions for the datatable
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    template: function (obj) {
                        // Template for rendering cell content
                        return "<span class='webix_icon wxi-close details'></span><span class='webix_icon wxi-close info'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // ID column
                {
                    id: 'DateTimeCreation', // DateTimeCreation column ID
                    header: _('Fecha/Hora Creación'), // Localized header
                    width: 200, // Column width
                    sort: 'int', // Sorting type
                },
                { id: 'Name', header: _('Nombres'), width: 150, sort: 'int' }, // Name column
                { id: 'Email', header: _('Email'), width: 250, sort: 'int' }, // Email column
                { id: 'Phone', header: _('Teléfono'), width: 100, sort: 'int' }, // Phone column
                {
                    id: 'Message', // Message column ID
                    header: _('Mensaje'), // Localized header
                    width: 400, // Column width
                    sort: 'int', // Sorting type
                },
            ],
            onClick: {
                // Event handlers for click events
                details: function (euv, id) {
                    // Handler for details icon click
                    var item = this.getItem(id); // Get the clicked item
                    var obj = JSON.parse(item.Message); // Parse the Message field
                    $$('data').parse(obj); // Load parsed data into the data view
                    $$('detailClaim').show(); // Show the detail claim popup
                },
                info: function (euv, id) {
                    // Handler for info icon click
                    this.$scope.app.callEvent('popupInfo:button', [[]]); // Trigger popupInfo event
                },
            },
            footer: false, // Disable footer
            loadahead: 0, // No preloading
            datafetch: devConfig.getDefaultDataFetch(), // Fetching configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var vthis = this; // Preserve context
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'Management/GetManagementClaims'; // API endpoint for claims
        var filter = ''; // Filter string
        var i = ''; // Temporary variable
        var popup = webix.ui({
            // Popup configuration for claim details
            view: 'window',
            id: 'detailClaim',
            width: screen.width < 500 ? 350 : 550, // Responsive width
            height: screen.width < 500 ? 600 : 400, // Responsive height
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                // Popup header
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Detalles Reclamo') }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Close button click handler
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Modal popup
            body: {
                // Popup body content
                view: 'scrollview',
                scroll: 'y',
                body: {
                    view: 'template',
                    id: 'data', // ID for the data template
                    height: 350, // Height of the template
                    css: 'movies', // CSS class for styling
                    scroll: 'y', // Enable vertical scrolling
                    template: function (obj) {
                        // Template function for rendering data
                        var string = ''; // Initialize string for HTML content
                        $.each(obj, function (index, value) {
                            // Iterate over object properties
                            vthis.i =
                                "<div class='overall'><div class='title'>" +
                                index +
                                "</div><div class='value'>" +
                                value +
                                '</div> </div>'; // Construct HTML for each property
                            string = string.concat(' ', vthis.i); // Concatenate to the string
                        });
                        return string; // Return the constructed HTML
                    },
                },
            },
        });
        this.on(this.app, 'managementContact:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate over filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to string
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Remove time from date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to filter
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to filter
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate over object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event for after sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event for item double-click
            var item = this.getItem(id); // Get clicked item
            var obj = JSON.parse(item.Message); // Parse the Message field
            $$('data').parse(obj); // Load parsed data into the data view
            popup.show(); // Show the detail claim popup
        });
        var popupInfo = webix.ui({
            // Popup configuration for information
            view: 'window',
            id: 'infoWindow', // ID for the info window
            width: 550, // Width of the info window
            height: 450, // Height of the info window
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
            head: {
                // Info window header
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Información') }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            // Close button click handler
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center the info window
            modal: true, // Modal popup
            body: {
                // Info window body content
                view: 'scrollview',
                scroll: 'xy',
                body: {
                    view: 'form',
                    id: 'infoForm', // ID for the info form
                    elements: [
                        // Form elements
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Id'), // ID field
                                    name: 'Id',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                },
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Fecha/Hora Creación'), // DateTimeCreation field
                                    name: 'DateTimeCreation',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Nombres'), // Name field
                                    name: 'Name',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                },
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Email'), // Email field
                                    name: 'Email',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'text',
                                    labelPosition: 'top',
                                    label: _('Teléfono'), // Phone field
                                    name: 'Phone',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                },
                            ],
                        },
                        {
                            margin: 10,
                            cols: [
                                {
                                    view: 'textarea',
                                    labelPosition: 'top',
                                    label: _('Mensaje'), // Message field
                                    name: 'Message',
                                    readonly: true, // Read-only field
                                    minWidth: 220,
                                    height: 150,
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'popupInfo:button', (filter) => {
            // Event listener for popup info button
            popupInfo.show(); // Show the info window
            $$('infoForm').bind($$('datatable')); // Bind the form to the datatable
        });
    }
}

// FILE DOCUMENTED
